import { companyProfileService } from '../../helpers/services/companyProfile.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  companyProfiles: { data: [] },
  status: { list: true, save: true },
}

export const COMPANY_PROFILE_MODULE = 'companyProfile'

export const GET_ALL_COMPANY_PROFILES = 'getAllCompanyProfiles'
export const CREATE_COMPANY_PROFILE = 'createCompanyProfile'
export const UPDATE_COMPANY_PROFILE = 'updateCompanyProfile'
export const SET_PRIMARY_COMPANY_PROFILE = 'setPrimaryCompanyProfile'
export const DELETE_COMPANY_PROFILE = 'deleteCompanyProfile'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const PROFILES_SUCCESS = 'profilesSuccess'

function mapProfile(item) {
  return {
    uuid: item.uuid,
    name: item.name,
    registrationNo: item.registration_no,
    ssmNumber: item.ssm_number,
    address: item.address,
    postcode: item.postcode,
    city: item.city,
    state: item.state,
    phone: item.phone,
    email: item.email,
    website: item.website,
    bankName: item.bank_name,
    bankAccount: item.bank_account,
    logoUrl: item.logo_url,
    themeColor: item.theme_color,
    pdfTemplate: item.pdf_template,
    designJson: item.design_json,
    docPrefix: item.doc_prefix,
    markupPercent: item.markup_percent,
    isPrimary: item.is_primary,
    isAutocount: item.is_autocount,
    isActive: item.is_active,
  }
}

export const actions = {
  [GET_ALL_COMPANY_PROFILES]({ commit }) {
    commit(REQUESTING, 'list')
    return companyProfileService.getAll().then((r) => {
      commit(PROFILES_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_COMPANY_PROFILE]({ commit, dispatch }, { data }) {
    commit(REQUESTING, 'save')
    return companyProfileService.create(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.companyProfile')]))
      commit(SUCCESS); dispatch(GET_ALL_COMPANY_PROFILES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_COMPANY_PROFILE]({ commit, dispatch }, { uuid, data }) {
    commit(REQUESTING, 'save')
    return companyProfileService.update(uuid, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.companyProfile')]))
      commit(SUCCESS); dispatch(GET_ALL_COMPANY_PROFILES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [SET_PRIMARY_COMPANY_PROFILE]({ commit, dispatch }, { uuid }) {
    return companyProfileService.setPrimary(uuid).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.companyProfile')]))
      commit(SUCCESS); dispatch(GET_ALL_COMPANY_PROFILES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [DELETE_COMPANY_PROFILE]({ commit, dispatch }, { uuid }) {
    return companyProfileService.remove(uuid).then((r) => {
      commit(SUCCESS); dispatch(GET_ALL_COMPANY_PROFILES); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [PROFILES_SUCCESS](state, data) { state.companyProfiles.data = (data.data || []).map(mapProfile) },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
